import { type PortableTextMarkComponentProps } from '@portabletext/react'
import cx from 'classnames'

interface ColoredTextValue {
  _type: 'textColor'
  color?: string
}

export const colorClasses: Record<string, string> = {
  white: 'text-white',
  black: 'text-black',
  gray: 'text-gray',
  'green-light': 'text-green-light',
  green: 'text-green',
  'green-electric': 'text-green-electric',
  'green-dark': 'text-green-dark',
  'pink-faded': 'text-pink-faded',
  pink: 'text-pink',
  'pink-hot': 'text-pink-hot',
  blue: 'text-blue',
  red: 'text-red',
  yellow: 'text-yellow',
}

const ColoredText = ({
  value,
  children,
}: PortableTextMarkComponentProps<ColoredTextValue>) => {
  return (
    <span className={cx(value?.color ? colorClasses[value.color] : '')}>
      {children}
    </span>
  )
}

export default ColoredText
